import MatchEvent from 'interfaces/matchEvent';
import { MatchEventType } from '../../../enums/matchEventType';

export default function (matchEvent: MatchEvent): boolean {
  return matchEvent.matchEventTypeId === MatchEventType.GOAL || matchEvent.matchEventTypeId === MatchEventType.OWN_GOAL;
}
